// frontend/src/components/NotificationChannelSelector.jsx

import React from 'react';
import { useTranslation } from '../i18n'
import { isValidPhoneNumber } from 'libphonenumber-js'; // 1. IMPORTA la función

function isValidEmail(v) {
  if (!v) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
}

// Devuelve true solo si el valor existe Y es un número de teléfono válido.
function isValidPhone(v) {
  return v ? isValidPhoneNumber(v) : false;
}

export default function NotificationChannelSelector({
  contactEmail,
  contactPhone,
  defaultEmail,
  defaultWhatsapp,
  defaultCcLeader,
  onChange
}) {
  const { _ } = useTranslation();
  const emailUsable = isValidEmail(contactEmail);
  const phoneUsable = isValidPhone(contactPhone);

  const [notifyByEmail, setNotifyByEmail] = React.useState(
    defaultEmail ?? emailUsable
  );
  const [notifyByWhatsapp, setNotifyByWhatsapp] = React.useState(
    defaultWhatsapp ?? false
  );
  const [ccLeader, setCcLeader] = React.useState(defaultCcLeader ?? false);

  // Si cambia email/phone externo, revalida disponibilidad
  React.useEffect(() => {
    if (!emailUsable && notifyByEmail) setNotifyByEmail(false);
  }, [emailUsable]); // eslint-disable-line

  React.useEffect(() => {
    if (!phoneUsable && notifyByWhatsapp) setNotifyByWhatsapp(false);
  }, [phoneUsable]); // eslint-disable-line

  // Notifica hacia el padre en cada cambio
  React.useEffect(() => {
    onChange?.({
      notify_by_email: !!notifyByEmail,
      notify_by_whatsapp: !!notifyByWhatsapp,
      cc_leader: !!ccLeader
    });
  }, [notifyByEmail, notifyByWhatsapp, ccLeader, onChange]);

  return (
    <fieldset className="w-full">
      <legend className="sr-only">
        {_('Notification channels')}
      </legend>

      <div className="flex flex-col gap-3">
        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            className="h-4 w-4 accent-blue-600"
            checked={notifyByEmail}
            onChange={(e) => setNotifyByEmail(e.target.checked)}
            disabled={!emailUsable}
            aria-describedby="help-email"
          />
          <span className="text-sm">
            {_('Notify by email')}
            {!emailUsable && (
              <span className="ml-1 text-xs text-slate-500">
                {_('(provide a valid email)')}
              </span>
            )}
          </span>
        </label>

        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            className="h-4 w-4 accent-emerald-600"
            checked={notifyByWhatsapp}
            onChange={(e) => setNotifyByWhatsapp(e.target.checked)}
            disabled={!phoneUsable}
            aria-describedby="help-whatsapp"
          />
        <span className="text-sm">
            {_('Notify by WhatsApp')}
            {!phoneUsable && (
              <span className="ml-1 text-xs text-slate-500">
                {_('(provide a valid phone)')}
              </span>
            )}
          </span>
        </label>

        <label className="inline-flex items-center gap-2">
          <input
            type="checkbox"
            className="h-4 w-4 accent-indigo-600"
            checked={ccLeader}
            onChange={(e) => setCcLeader(e.target.checked)}
          />
          <span className="text-sm">
            {_('Send a copy to the leader')}
          </span>
        </label>
      </div>

      <p id="help-email" className="mt-2 text-xs text-slate-500">
        {_('Email channel will be enabled only if a valid email is present.')}
      </p>
      <p id="help-whatsapp" className="text-xs text-slate-500">
        {_('WhatsApp channel will be enabled only if a valid phone is present.')}
      </p>
    </fieldset>
  );
}
